import * as React from "react";
import { memo } from "react";

const SvgMalingoetzSoap = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.444 7.778A2.779 2.779 0 0 0 11.667 5h-.556v-.556c0-.91-.755-1.666-1.667-1.666H8.89V1.11h.978a4.98 4.98 0 0 1 2.11.489.506.506 0 0 0 .245.067c.2 0 .4-.111.49-.311.132-.267.021-.6-.245-.756-.8-.378-1.69-.6-2.6-.6H4.444a.55.55 0 0 0-.555.556.55.55 0 0 0 .555.555h1.112v1.667H5c-.911 0-1.667.755-1.667 1.666V5h-.555A2.779 2.779 0 0 0 0 7.778v9.444A2.779 2.779 0 0 0 2.778 20h8.889a2.779 2.779 0 0 0 2.777-2.778V7.778ZM6.667 1.11h1.11v1.667h-1.11V1.11ZM4.444 4.444A.55.55 0 0 1 5 3.89h4.444a.55.55 0 0 1 .556.555V5H4.444v-.556Zm8.89 12.778c0 .911-.756 1.667-1.667 1.667h-8.89a1.679 1.679 0 0 1-1.666-1.667V7.778c0-.911.756-1.667 1.667-1.667h8.889c.91 0 1.666.756 1.666 1.667v9.444Z"
      fill="#000"
    />
  </svg>
);

const Memo = memo(SvgMalingoetzSoap);
export default Memo;
